/* ============================================================
   CRO PDP — Apple-style accordion animation
   ------------------------------------------------------------
   The theme's PDP accordions are native
   <details class="collapsible-tab">.

   We intercept the <summary> click so opening / closing can
   animate smoothly while still keeping native <details> state.

   PDP accordions:
   - smooth open / close
   - only one PDP panel open at once
   - opening another automatically closes the previous one
   - NO forced scroll-position correction
   - avoids the recoil / shaking caused by repeated scrollBy()

   CRO FAQ:
   - same smooth animation
   - multiple answers may remain open
   ============================================================ */

(function () {

  var EASE =
    'cubic-bezier(0.32, 0.72, 0, 1)';

  var DUR = 420;


  /* ============================================================
     SIBLINGS
     Every OTHER panel in the same accordion group.
     ============================================================ */

  function siblings(details, opts) {

    var scope =
      (
        details.closest &&
        details.closest(opts.scope)
      ) ||
      document;


    return Array.prototype.filter.call(
      scope.querySelectorAll(opts.item),
      function (item) {
        return item !== details;
      }
    );

  }


  /* ============================================================
     BIND ACCORDION GROUP
     ============================================================ */

  function bindGroup(opts, reduced) {

    Array.prototype.forEach.call(
      document.querySelectorAll(opts.item),
      function (details) {


        if (details.dataset.croAccBound) {
          return;
        }


        details.dataset.croAccBound = '1';


        var summary =
          details.querySelector(opts.summary);


        var content =
          details.querySelector(opts.content);


        if (!summary || !content) {
          return;
        }


        /* ------------------------------------------------------
           Store original padding
           ------------------------------------------------------ */

        var computed =
          window.getComputedStyle(content);


        var padTop =
          computed.paddingTop;


        var padBottom =
          computed.paddingBottom;


        /* ------------------------------------------------------
           Animation rules
           ------------------------------------------------------ */

        content.style.transition =
          'height ' +
          DUR +
          'ms ' +
          EASE +
          ', opacity 0.28s ease' +
          ', padding ' +
          DUR +
          'ms ' +
          EASE;


        content.style.overflow =
          'hidden';


        content.style.willChange =
          'height';


        /* ------------------------------------------------------
           Initial closed state
           ------------------------------------------------------ */

        if (!details.open) {

          content.style.height =
            '0px';


          content.style.opacity =
            '0';


          content.style.paddingTop =
            '0px';


          content.style.paddingBottom =
            '0px';

        }


        /* ======================================================
           SETTLE

           Runs callback once after height animation ends,
           with timer fallback for auto -> 0 cases.
           ====================================================== */

        var settle =
          function (fn) {


            var done = false;


            var finish =
              function (event) {


                if (
                  event &&
                  event.propertyName !== 'height'
                ) {
                  return;
                }


                if (done) {
                  return;
                }


                done = true;


                content.removeEventListener(
                  'transitionend',
                  finish
                );


                clearTimeout(timer);


                fn();

              };


            var timer =
              setTimeout(
                finish,
                DUR + 120
              );


            content.addEventListener(
              'transitionend',
              finish
            );

          };


        /* ======================================================
           CLOSE
           ====================================================== */

        var closeTab =
          function () {


            if (!details.open) {
              return;
            }


            /*
              Always start from an explicit pixel height.
              Never animate from height:auto.
            */

            content.style.height =
              content.scrollHeight + 'px';


            content.style.paddingTop =
              padTop;


            content.style.paddingBottom =
              padBottom;


            /*
              Commit starting layout.
            */

            content.offsetHeight;


            requestAnimationFrame(
              function () {


                content.style.height =
                  '0px';


                content.style.opacity =
                  '0';


                content.style.paddingTop =
                  '0px';


                content.style.paddingBottom =
                  '0px';

              }
            );


            settle(
              function () {


                details.open =
                  false;


                content.style.height =
                  '0px';

              }
            );

          };


        /*
          Expose close method so another accordion
          can close this one.
        */

        details.croClose =
          closeTab;


        /* ======================================================
           OPEN
           ====================================================== */

        var openTab =
          function () {


            /*
              Open native <details> first so content exists
              in normal document flow.
            */

            details.open =
              true;


            content.style.height =
              '0px';


            content.style.opacity =
              '0';


            content.style.paddingTop =
              '0px';


            content.style.paddingBottom =
              '0px';


            /*
              Final open state.
            */

            settle(
              function () {


                content.style.height =
                  'auto';


                content.style.opacity =
                  '1';


                content.style.paddingTop =
                  padTop;


                content.style.paddingBottom =
                  padBottom;

              }
            );


            /*
              Measure natural height and animate towards it.
            */

            requestAnimationFrame(
              function () {


                content.style.paddingTop =
                  padTop;


                content.style.paddingBottom =
                  padBottom;


                var target =
                  content.scrollHeight;


                /*
                  Return to 0 instantly before starting
                  the actual animated frame.
                */

                content.style.height =
                  '0px';


                content.offsetHeight;


                requestAnimationFrame(
                  function () {


                    content.style.height =
                      target + 'px';


                    content.style.opacity =
                      '1';

                  }
                );

              }
            );

          };


        /* ======================================================
           CLICK
           ====================================================== */

        summary.addEventListener(
          'click',
          function (event) {


            event.preventDefault();


            /*
              PDP accordion:
              close every other open panel before opening
              the newly selected one.

              IMPORTANT:
              No anchor() / scrollBy() compensation here.

              The panel heights already animate smoothly,
              so the browser is allowed to maintain its natural
              scroll position rather than being corrected on
              every animation frame.
            */

            if (
              opts.exclusive &&
              !details.open
            ) {


              Array.prototype.forEach.call(
                siblings(details, opts),
                function (other) {


                  if (!other.open) {
                    return;
                  }


                  if (
                    reduced ||
                    typeof other.croClose !==
                    'function'
                  ) {

                    other.open =
                      false;

                  } else {

                    other.croClose();

                  }

                }
              );

            }


            /* Reduced motion */

            if (reduced) {

              details.open =
                !details.open;

              return;

            }


            /* Normal animation */

            if (details.open) {

              closeTab();

            } else {

              openTab();

            }

          }
        );

      }
    );

  }


  /* ============================================================
     INIT
     ============================================================ */

  function init() {


    var reduced =
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    /* ----------------------------------------------------------
       PDP BUY-BOX ACCORDIONS
       One open at a time.
       ---------------------------------------------------------- */

    bindGroup(
      {

        item:
          '.product-container details.collapsible-tab',

        scope:
          '.product-container',

        summary:
          'summary, .collapsible-tab__heading',

        content:
          '.collapsible-tab__text',

        exclusive:
          true

      },
      reduced
    );


    /* ----------------------------------------------------------
       CRO FAQ
       Multiple answers may remain open.
       ---------------------------------------------------------- */

    bindGroup(
      {

        item:
          'details.cro-faq__item',

        scope:
          '.cro-faq',

        summary:
          'summary',

        content:
          '.cro-faq__answer',

        exclusive:
          false

      },
      reduced
    );

  }


  if (
    document.readyState !==
    'loading'
  ) {

    init();

  } else {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  }


  /* Theme editor section reload */

  document.addEventListener(
    'shopify:section:load',
    init
  );

})();